<template>
  <div v-if="shuffled.length > 0" v-on:mouseover="stopRotation()" v-on:mouseout="startRotation()"
       style="margin-bottom: 2rem;" class="new-box with-left-image with-overflow">
    <div style="height: 350px; overflow: hidden;">
      <h6 class="box-headline">{{ bundle.id_10883 }}</h6>
      <transition-group name="new-job-in-focus-list" tag="ul" class="new-job-in-focus-list">
        <li v-for="job in shuffled" v-bind:key="'job' + (job ? job.id : '')">
          <a v-bind:href="job.href">
            <span v-if="job.logo">
              <img v-bind:src="job.logo"/>
            </span>
            <span>{{ job.title }}</span>
          </a>
        </li>
      </transition-group>
    </div>
    <a v-bind:href="computedMoreLink" class="see-all">
      {{ bundle.id_11401 }}
      <i class="fas fa-caret-right"></i>
    </a>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "job-in-focus-box",
  props: {
    value: {
      type: Array,
      required: true
    },
    shuffle: {
      type: Boolean,
      default: false
    },
    moreLink: {
      type: String,
      default: "/job"
    }
  },
  data: function () {
    return {
      contextPath: window.contextPath,
      ready: false,
      shuffled: [],
      rotation: null,
      bundle: {
        id_10883: "Featured Jobs",
        id_11401: "Go to job overview"
      }
    };
  },
  created: function () {
    var instance = this;
    Vue.$bundle("portal", instance.bundle, function (bundle) {
      instance.bundle = bundle;
    });
    if (instance.shuffle) {
      for (var i = 0; i < instance.value.length; i++) {
        instance.shuffled.splice(
            Math.floor(Math.random() * (instance.shuffled.length + 1)),
            0,
            instance.value[i]);
      }
    } else {
      for (var j = 0; j < instance.value.length; j++) {
        instance.shuffled.push(instance.value[j]);
      }
    }
    instance.startRotation();
  },
  mounted: function () {
    if (this.value) {
      for (var i = 0; i < this.value.length; i++) {
        this.$track("impression", "job", this.value[i].id);
      }
    }
  },
  computed: {
    computedMoreLink: function () {
      if (this.moreLink.startsWith("/")) {
        return this.contextPath + this.moreLink;
      }
      return this.moreLink;
    }
  },
  methods: {
    startRotation: function () {
      var instance = this;
      if (instance.shuffled.length > 3) {
        instance.rotation = setInterval(function () {
          var job = instance.shuffled.splice(0, 1)[0];
          setTimeout(function () {
            instance.shuffled.push(job);
          }, 1000);
        }, 5000);
      }
    },
    stopRotation: function () {
      var instance = this;
      clearInterval(instance.rotation);
      instance.rotation = null;
    }
  }
}
</script>
